__turbopack_context__.v({
  "image": "storiesGrid-module-scss-module__xpOtEG__image",
  "image_wrapper": "storiesGrid-module-scss-module__xpOtEG__image_wrapper",
  "introduction": "storiesGrid-module-scss-module__xpOtEG__introduction",
  "main": "storiesGrid-module-scss-module__xpOtEG__main",
  "noResults": "storiesGrid-module-scss-module__xpOtEG__noResults",
  "story": "storiesGrid-module-scss-module__xpOtEG__story",
  "story_title": "storiesGrid-module-scss-module__xpOtEG__story_title",
  "type": "storiesGrid-module-scss-module__xpOtEG__type",
  "wrapper": "storiesGrid-module-scss-module__xpOtEG__wrapper",
});
